import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    border: ' 1px solid #C5CED6',
    padding: '1rem',
    borderRadius: '35px',

    ' &:focus': {
      border: ' 1px solid #C5CED6',
    },

    ' &:focus-visible': {
      border: ' 1px solid #C5CED6',
      outline: 'none',
    },

    '&:active': {
      border: ' 1px solid #C5CED6',
    },
    resize: 'none',
    fontSize: 'inherit',
    fontFamily: lato.style.fontFamily,

    [theme.breakpoints.down('md')]: {
      borderRadius: '24px',
    },
  },
  error: {
    color: '#ff1744',
    fontSize: '.75rem',
    fontFamily: 'sans-serif',
    padding: '0',
    margin: '3px 0',
    textAlign: 'start',
    paddingLeft: '10px',
  },
}))

export default useStyles
